import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DashboardMainContainer from "../common/Containers/DashboardMainContainer";
import {
  AdminMainText,
  AdminMetadataText,
  AdminSupportingText,
  AdminMetric,
  AdminFormSecondaryAction,
} from "../../sections/AdminDashboard/shared/adminUx";
import { AdminWidgetHeader, AdminWidgetPeriodFilter } from "../BusinessDashboard/AdminWidgetChrome";
import {
  dashboardChartTooltipHeading,
  dashboardChartTooltipSeriesRow,
} from "../BusinessDashboard/dashboardChartTooltip";
import * as echarts from "echarts";

const MessagesWidget = () => {
  const navigate = useNavigate();
  const chartRef = useRef(null);
  const [filterPeriod, setFilterPeriod] = useState("Last 7 Days");

  // Dynamic data for different time periods
  const messagesDataByPeriod = {
    'Last 7 Days': {
      totalMessages: 24,
      unreadCount: 7,
      messages: [
        {
          id: 1,
          sender: "Liberty Plumbing",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: true,
          message: "Yes, we can come tomorrow at 10am to fix the leak under your sink. Please confirm the address again…",
          timestamp: "2h ago",
          isUnread: true
        },
        {
          id: 2,
          sender: "Apex Electrical",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: false,
          message: "Thanks for the updated quote.",
          timestamp: "Yesterday",
          isUnread: true
        },
        {
          id: 3,
          sender: "Sparkle Cleaners",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: false,
          message: "Great, looking forward to it!",
          timestamp: "2d ago",
          isUnread: false
        },
        {
          id: 4,
          sender: "Quick Fix Carpentry",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: true,
          message: "The door frame repair is complete. Please check the work when convenient.",
          timestamp: "3d ago",
          isUnread: false
        }
      ]
    },
    'Last 14 Days': {
      totalMessages: 38,
      unreadCount: 12,
      messages: [
        {
          id: 1,
          sender: "Liberty Plumbing",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: true,
          message: "Yes, we can come tomorrow at 10am to fix the leak under your sink. Please confirm the address again…",
          timestamp: "2h ago",
          isUnread: true
        },
        {
          id: 4,
          sender: "Pro Painters",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: true,
          message: "We have availability next week for the exterior painting job.",
          timestamp: "5d ago",
          isUnread: true
        },
        {
          id: 5,
          sender: "Garden Masters",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: false,
          message: "Your lawn maintenance is scheduled for Monday morning.",
          timestamp: "8d ago",
          isUnread: false
        },
        {
          id: 6,
          sender: "Elite Flooring",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: true,
          message: "The hardwood floor installation is progressing well. We'll finish by Friday.",
          timestamp: "10d ago",
          isUnread: true
        }
      ]
    },
    'Last 30 Days': {
      totalMessages: 67,
      unreadCount: 18,
      messages: [
        {
          id: 1,
          sender: "Liberty Plumbing",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: true,
          message: "Yes, we can come tomorrow at 10am to fix the leak under your sink. Please confirm the address again…",
          timestamp: "2h ago",
          isUnread: true
        },
        {
          id: 6,
          sender: "Roof Experts",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: true,
          message: "Roof inspection completed. Report attached.",
          timestamp: "15d ago",
          isUnread: true
        },
        {
          id: 7,
          sender: "Clean Pro Services",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: false,
          message: "Thank you for choosing us! We'll see you next month.",
          timestamp: "22d ago",
          isUnread: false
        },
        {
          id: 8,
          sender: "Master Builders",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: true,
          message: "The renovation project is on schedule. Next phase starts Monday.",
          timestamp: "25d ago",
          isUnread: false
        }
      ]
    },
    'Last 90 Days': {
      totalMessages: 142,
      unreadCount: 23,
      messages: [
        {
          id: 1,
          sender: "Liberty Plumbing",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: true,
          message: "Yes, we can come tomorrow at 10am to fix the leak under your sink. Please confirm the address again…",
          timestamp: "2h ago",
          isUnread: true
        },
        {
          id: 8,
          sender: "Elite HVAC",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: true,
          message: "Your air conditioning system has been serviced successfully.",
          timestamp: "45d ago",
          isUnread: false
        },
        {
          id: 9,
          sender: "Locksmith 24/7",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: false,
          message: "New locks installed. Keys are ready for pickup.",
          timestamp: "68d ago",
          isUnread: false
        },
        {
          id: 10,
          sender: "Solar Solutions",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          isPro: true,
          message: "Solar panel installation completed. System is now generating power.",
          timestamp: "75d ago",
          isUnread: false
        }
      ]
    }
  };

  // Get current period data
  const messagesData = messagesDataByPeriod[filterPeriod];
  const sampleMessages = messagesData.messages;

  // Initialize donut chart
  useEffect(() => {
    if (chartRef.current) {
      const chart = echarts.init(chartRef.current);
      const readMessages = messagesData.totalMessages - messagesData.unreadCount;
      
      const option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: '#e5e7eb',
          borderWidth: 1,
          textStyle: { color: '#374151' },
          renderMode: 'html',
          formatter(params) {
            if (!params) return "";
            return (
              dashboardChartTooltipHeading(params.name) +
              dashboardChartTooltipSeriesRow(params, "Messages")
            );
          },
        },
        legend: {
          show: false
        },
        series: [
          {
            name: 'Messages',
            type: 'pie',
            radius: ['60%', '90%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: false
              },
              scale: false
            },
            labelLine: {
              show: false
            },
            data: [
              { 
                value: readMessages, 
                name: 'Read',
                itemStyle: { color: '#2e00ff' }
              },
              { 
                value: messagesData.unreadCount, 
                name: 'Unread',
                itemStyle: { color: '#d5ccff' }
              }
            ]
          }
        ]
      };
      chart.setOption(option);
      
      // Handle window resize
      const handleResize = () => chart.resize();
      window.addEventListener('resize', handleResize);
      
      // Cleanup
      return () => {
        window.removeEventListener('resize', handleResize);
        chart.dispose();
      };
    }
  }, [filterPeriod, messagesData.totalMessages, messagesData.unreadCount]);

  const handleViewAll = () => {
    navigate("/customer-dashboard/inbox/chats");
  };

  const handleMessageClick = (messageId) => {
    navigate(`/customer-dashboard/inbox/chats`);
  };

  return (
    <DashboardMainContainer className="masonry-item w-[400px] h-[600px] flex flex-col overflow-hidden">
      <AdminWidgetHeader title="Messages">
        <AdminWidgetPeriodFilter
          period={filterPeriod}
          onPeriodChange={setFilterPeriod}
          periods={["Last 7 Days", "Last 14 Days", "Last 30 Days", "Last 90 Days"]}
        />
      </AdminWidgetHeader>

      <div className="p-4 space-y-4">
        {/* Data Summary Block */}
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-end gap-6">
              {/* Total Messages */}
              <div>
                <AdminMetric size="large" className="text-offblack mb-1 block">
                  {messagesData.totalMessages}
                </AdminMetric>
                <AdminSupportingText className="text-offblack block">Total Messages</AdminSupportingText>
                <div className="flex items-center gap-1 mt-1">
                  <AdminMetric size="small" className="text-offblack">
                    {messagesData.unreadCount}
                  </AdminMetric>
                  <AdminSupportingText className="text-offblack">Unread</AdminSupportingText>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div ref={chartRef} className="w-24 h-24" />
          </div>
        </div>

        {/* Message Threads */}
        <div className="space-y-0 border-t border-lightgray pt-3">
          {sampleMessages.length > 0 ? (
            sampleMessages.map((message, index) => (
              <div key={message.id}>
                <div
                  onClick={() => handleMessageClick(message.id)}
                  className="cursor-pointer transition-colors py-3 hover:bg-mistygray rounded-lg"
                >
                  <div className="flex items-start gap-3">
                    <div className="relative flex-shrink-0">
                      <img
                        className="object-cover rounded-full w-10 h-10 flex-shrink-0 cursor-pointer"
                        src={message.profileImage}
                        alt={message.sender}
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between mb-1">
                        <div className="flex items-center gap-2">
                          <AdminMainText
                            className={`font-medium ${message.isUnread ? "text-offblack" : "text-mediumgray"}`}
                          >
                            {message.sender}
                          </AdminMainText>
                        </div>
                        <AdminMetadataText className="flex-shrink-0 ml-2">{message.timestamp}</AdminMetadataText>
                      </div>
                      <AdminMainText
                        className={`w-[85%] line-clamp-2 block ${message.isUnread ? "text-offblack" : "text-mediumgray"}`}
                      >
                        {message.message}
                      </AdminMainText>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-6">
              <AdminSupportingText className="text-offblack mb-2 block">
                No messages yet for this period.
              </AdminSupportingText>
              <AdminMetadataText className="text-mediumgray block">
                Start a conversation when you contact a trade.
              </AdminMetadataText>
            </div>
          )}
        </div>

        {/* View All Messages Button */}
        <div className="pt-2">
          <AdminFormSecondaryAction type="button" onClick={handleViewAll} className="!w-full">
            View all messages
          </AdminFormSecondaryAction>
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default MessagesWidget;
